<template>
  <RDialog
    :activator="activator"
    :title="title || 'Fatal Webservice Error'"
    maxWidth="550px"
    persistent
  >
    <template #content>
      <v-card-text class="pt-2 text-body-2">
        <v-row v-if="text" class="px-1">
          <v-col>
            <v-row>
              <v-col>
                <span>{{ text }}</span>
              </v-col>
            </v-row>
            <v-row v-if="errorMessage">
              <v-col>
                <v-row class="ma-0">
                  Error Details:
                </v-row>
                <v-row class="ma-0 px-1">
                  <span>{{ errorMessage }}</span>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row v-else class="px-1">
          <v-col>
            <v-row>
              <v-col>
                <span>A fatal error was encountered when communicating with the server.</span>
              </v-col>
            </v-row>
            <v-row v-if="isDevelopment">
              <v-col class="py-0">
                <span>Server Debug is enabled, output can be found <a :href="debugLink" target="_blank">here</a>.</span>
              </v-col>
            </v-row>
            <v-row v-else>
              <v-col class="py-0">
                <span>Please share this error message with your system administrator.</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-row class="ma-0">
                  Error Message:
                </v-row>
                <v-row class="ma-0 px-2">
                  <span class="font-weight-bold ">{{ errorMessage }}</span>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </template>
    <template #actions>
      <v-card-actions>
        <v-spacer />
        <v-btn
          v-if="isDevelopment"
          text
          @click="toggleDialog(false)"
        >
          Ok
        </v-btn>
      </v-card-actions>
    </template>
  </RDialog>
</template>

<script setup>
import { computed, onBeforeMount } from 'vue';
import { useStore } from 'vuex';
import RDialog from '@/components/core/common/RDialog.vue';

defineProps({
  activator: {
    type: Boolean,
    required: true,
  },
});

const store = useStore();

const isDevelopment = computed(() => process.env.NODE_ENV === 'development');

const debugLink = computed(() => store.getters['notify/debugLink']);
const errorMessage = computed(() => store.getters['notify/errorMessage']);
const title = computed(() => store.getters['notify/fatalErrorTitle']);
const text = computed(() => store.getters['notify/fatalErrorText']);

const toggleDialog = (bool) => store.dispatch('notify/toggleFatalErrorModal', { bool });

onBeforeMount(() => {
  if (!isDevelopment.value) store.dispatch('cached/invalidateScreenData');
});
</script>
